import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { HomeComponent } from './components/home/home.component';
import { gdprGuard } from './guards/gdpr.guard';
import { LogoutComponent } from './logout/logout.component';
import { RedirectComponent } from './redirect/redirect.component';

export const APP_ROUTES: Routes = [
  {
    path: 'redirect',
    component: RedirectComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    canActivate: [MsalGuard]
  },
  {
    path: 'bat',
    loadComponent: () =>
      import('./bat/bat.component').then((m) => m.BatComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'mkt-bat',
    loadComponent: () =>
      import('./mkt-bat/mkt-bat.component').then((m) => m.MktBatComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'mkt-bat-ita',
    loadComponent: () =>
      import('./mkt-bat-ita/mkt-bat-ita.component').then(
        (m) => m.MktBatItaComponent
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'communication-tool',
    loadChildren: () =>
      import('./communication-tool/communication-tool.routes').then(
        (m) => m.COMMUNICATION_TOOL_ROUTES
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'sales-periods',
    loadChildren: () =>
      import('./sales-periods/sales-periods.routes').then(
        (m) => m.SALES_PERIODS_ROUTES
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'mkt-calendar-view',
    loadChildren: () =>
      import('./mkt-calendar-view/mkt-calendar-view.routes').then(
        (m) => m.MKT_CALENDAR_VIEW_ROUTES
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'sales-calendar-view',
    loadChildren: () =>
      import('./sales-calendar-view/sales-calendar-view.routes').then(
        (m) => m.SALES_CALENDAR_VIEW_ROUTES
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'tm-calendar-view',
    loadComponent: () =>
      import('./tm-calendar-view/tm-calendar-view.component').then(
        (m) => m.TmCalendarViewComponent
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'opportunity-search',
    loadChildren: () =>
      import('./opportunity-search/opportunity-search.routes').then(
        (m) => m.OPPORTUNITY_SEARCH_ROUTES
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'opportunity-creation',
    loadChildren: () =>
      import('./opportunity-creation/opportunity-creation.routes').then(
        (m) => m.OPPORTUNITY_CREATION_ROUTES
      ),
    canActivate: [MsalGuard, gdprGuard]
  },
  {
    path: 'opportunity-detail',
    loadChildren: () =>
      import('./opportunity-detail/opportunity-detail.routes').then(
        (m) => m.OPPORTUNITY_DETAIL_ROUTES
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'files-management',
    loadComponent: () =>
      import('./files-management/files-management.component').then(
        (m) => m.FilesManagementComponent
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'installations',
    loadChildren: () =>
      import('./installations/installations.routes').then(
        (m) => m.INSTALLATIONS_ROUTES
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'digital-ole',
    loadComponent: () =>
      import('./digital-ole/digital-ole.component').then(
        (m) => m.DigitalOleComponent
      ),
    canActivate: [MsalGuard]
  },
  {
    path: 'digital-ole/offer-details',
    loadComponent: () =>
      import('./digital-ole/components/offer-details/offer-details.component').then(
        (m) => m.OfferDetailsComponent
      ),
    canActivate: [MsalGuard]
  }
];
